export const cardSearchQuerySelector = (state) => state.cards.query
